export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.carcareers.jobseeker';
export const APP_STORE_URL = 'https://apps.apple.com/us/app/carcareers-com/id6748094226';
